// @flow
import React from 'react'
import styled from 'styled-components'

const Component = styled.table`
  width: 100%;
  margin-bottom: 1rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
`

type Props = {
  children?: any,
  style?: Object
}

const Table = ({ children, style }: Props) => (
  <Component style={style}>{children}</Component>
)

export default Table



// WEBPACK FOOTER //
// ./src/components/Table/index.js